<template>
    <div style="height: 100%">
        <div class="my-2" v-if="code!='RC04'">
            <div class="label-request-details">Транспортное средство</div>
            <span class="text-request-details">{{detailModel!=null?detailModel.carMarkName+' '+detailModel.carModelName +', '+ detailModel.carYear:''}}</span>
        </div>
        <template v-if="code=='RC01'">
            <div class="my-2">
                <div class="label-request-details">Тема обращения</div>
                <span class="text-request-details">{{detailModel!=null?detailModel.requestCategoryName:''}}</span>
            </div>
            <div class="my-2">
                <div class="label-request-details">Описание проблемы</div>
                <span class="text-request-details">{{detailModel!=null?detailModel.requestText:''}}</span>
            </div>

            <div  v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc" class="label-request-details">Прикрепленные файлы</div>
            <attachments v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc"></attachments>
        </template>

        <template v-if="code=='RC02'">
            <!-- Темы обращения-->
            <div class="my-2">
                <div class="label-request-details">Тема обращения</div>
                <div v-if="detailModel!=null&&detailModel.serviceTypeValues.length>0">
                    <span v-for="topic in detailModel.serviceTypeValues" class="text-request-details">
                        {{topic}}
                    </span>
                    <template  v-if="detailModel!=null&&detailModel.requestParam.length>0">
                        <span v-for="param in detailModel.requestParam">
                            <span v-if="param.requestParamType=='bool'&&param.paramValue==true" class="text-request-details">{{', '+param.paramName}}</span>
                        </span>
                    </template>
                </div>
            </div>
            <div class="my-2">
                <div class="label-request-details">Описание проблемы</div>
                <span class="text-request-details">{{detailModel!=null?detailModel.requestText:''}}</span>
            </div>


            <div v-if="detailModel!=null">
                <div v-if="detailModel.latitude<=0&&detailModel.longitude<=0&&detailModel.locationText!=''" class="label-request-details">Местоположение</div>
                <div v-if="detailModel.latitude<=0&&detailModel.longitude<=0">{{detailModel.locationText}}</div>
                <googleMap v-if="detailModel.latitude>0&&detailModel.longitude>0" class="my-2"
                           :name="'userPosition'"
                           :lat-c="detailModel.latitude"
                           :lng-c="detailModel.longitude"
                           :h="'200px'"
                           :w="'100%'"
                />
            </div>

            <div v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc" class="label-request-details">Прикрепленные файлы</div>
            <attachments v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc"></attachments>

        </template>

        <!--Шаблон для подбора сервиса-->
        <template v-if="code=='RC03'">
            <div class="my-2">
                <div class="label-request-details">Тема обращения</div>
                <div v-if="detailModel!=null&&detailModel.serviceTypeValues.length>0">
                    <span v-for="(topic, index) in detailModel.serviceTypeValues" class="text-request-details">

                        {{(index>0?", ":'')+ topic}}
                    </span>
                    <template  v-if="detailModel!=null&&detailModel.requestParam.length>0">
                        <span v-for="param in detailModel.requestParam">
                            <span v-if="param.requestParamType=='bool'&&param.paramValue==true" class="text-request-details">{{', '+param.paramName}}</span>
                        </span>
                    </template>
                </div>
            </div>
            <div class="my-2">
                <div class="label-request-details">Описание проблемы</div>
                <span class="text-request-details">{{detailModel!=null?detailModel.requestText:''}}</span>
            </div>


            <div v-if="detailModel!=null">
                <div v-if="detailModel.latitude<=0&&detailModel.longitude<=0&&detailModel.locationText!=''" class="label-request-details">Местоположение</div>
                <div v-if="detailModel.latitude<=0&&detailModel.longitude<=0">{{detailModel.locationText}}</div>
                <googleMap v-if="detailModel.latitude>0&&detailModel.longitude>0" class="my-2"
                           :name="'userPosition'"
                           :lat-c="detailModel.latitude"
                           :lng-c="detailModel.longitude"
                           :h="'200px'"
                           :w="'100%'"
                />
            </div>

            <div  v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc" class="label-request-details">Прикрепленные файлы</div>
            <attachments v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc"></attachments>
        </template>

        <!--Шаблон для страховой заявки-->
        <template v-if="code=='RC04'">
            <div v-if="detailModel!=null">
                <div class="my-4">
                    <div class="label-request-details">Тема обращения</div>
                    <span class="text-request-details" style="font-weight: 600;"> Страхование {{detailModel!=null?detailModel.insurerType:''}}</span>
                </div>
                <!--Шаблон для грин карты-->
                <template v-if="detailModel.insuranceTypeCode=='IT04'">
                    <div class="my-6" >
                        <div class="label-request-details">Тип транспортного средства</div>
                        <span class="text-request-details">{{detailModel.autoType}}</span>
                    </div>
                    <div class="my-2" >
                        <div class="label-request-details">Страна пребывания</div>
                        <span class="text-request-details">{{detailModel.countryStay}}</span>
                    </div>
                    <div class="my-2" >
                        <div class="label-request-details">Срок пребывания</div>
                        <span class="text-request-details">{{detailModel.periodStay+ ' '+months(detailModel.periodStay)}}</span>
                    </div>
                </template>
                <template v-else>
                    <div class="my-2" >
                        <div class="label-request-details">Транспортное средство</div>
                        <span class="text-request-details">{{detailModel.carMarkName+' '+detailModel.carModelName+', '+detailModel.carYear}}</span>
                    </div>
                    <div class="my-2" >
                        <div class="label-request-details">Кол-во ЛС</div>
                        <span class="text-request-details">{{detailModel.horsePower}}</span>
                    </div>
                    <div class="mt-2 mb-4" >
                        <div class="label-request-details">Предполагаемая стоимость</div>
                        <span class="text-request-details">{{detailModel.autoPrice}}</span>
                    </div>
                    <div class="my-2" >
                        <div class="label-request-details">Дата рождения</div>
                        <span class="text-request-details">{{detailModel.birthDate!=null?formatDate(detailModel.birthDate):'-'}}</span>
                    </div>
                    <div class="my-2" >
                        <div class="label-request-details">Номер водительского удостоверения</div>
                        <span class="text-request-details">{{detailModel.driverNumber!=null?detailModel.driverNumber:'Не указано'}}</span>
                    </div>
                    <div class="my-2" >
                        <div class="label-request-details">Дата начала стажа</div>
                        <span class="text-request-details">{{detailModel.expStartType!=null?formatDate(detailModel.expStartType):'Не указано'}}</span>
                    </div>
                    <div class="my-2" >
                        <div class="label-request-details">Регион прописки</div>
                        <span class="text-request-details">{{detailModel.residenceRegion!=null?detailModel.residenceRegion:'Не указано'}}</span>
                    </div>
                </template>

                <div class="my-4" >
                    <div class="label-request-details">Номер телефона</div>
                    <span class="text-request-details">{{detailModel.phoneNumber}}</span>
                </div>

            </div>
        </template>
    </div>
</template>

<script>

    /*
    * RC01 - Юридическая помощь
    * RC02 - Оценка ущерба
    * RC03 - Помощь автосервиса
    * RC04 - Страховка
    * */
    import API from '../../services/apiService.js'
    var api= new API();
    import googleMap from '../googleMap.vue'
    import attachments from './DetailsRequestAttachments.vue'
    export default {
        name: "RequestsNewDetails",
        props:["code", "requestId"],
        components:{googleMap, attachments},
        data(){
            return {
                detailModel:null,

            }
        },
        beforeMount(){
            if(this.requestId!=null){
                //заполняем детализацию в зависимости от категории
                switch (this.code){
                    case "RC01":{
                        api.Get("RequestService/Request/LawyerRequest?requestId="+this.requestId).then((data)=>{
                            this.detailModel=data
                        }).catch(err=>{
                            console.log(err)
                        })
                        break;
                    }
                    case "RC02":{
                        api.Get("RequestService/Request/DamageRequest?requestId="+this.requestId).then((data)=>{
                            this.detailModel=data
                        }).catch(err=>{
                            console.log(err)
                        })
                        break;
                    }
                    case "RC03":{
                        api.Get("RequestService/Request/ServiceRequest?requestId="+this.requestId).then((data)=>{
                            this.detailModel=data
                        }).catch(err=>{
                            console.log(err)
                        })
                        break;
                    }
                    case "RC04":{
                        api.Get("RequestService/Request/InsuranceRequest?requestId="+this.requestId).then((data)=>{
                            this.detailModel=data
                        }).catch(err=>{
                            console.log(err)
                        })
                        break;
                    }
                }
            }
        },
        methods:{

            months(count){
                let num= count%10 //последняя цифра в числе
                if(num==1){
                    return 'Месяц'
                }
                if(num>1&&num<5) {
                    return 'Месяца'
                }
                else
                    return 'Месяцев'
            }

        },

    }
</script>

<style scoped>

    .label-request-details{
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color:var(--color-2);
    }

    .text-request-details{
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color:#1A2A3A;
    }
</style>